import { render, staticRenderFns } from "./Substitution.vue?vue&type=template&id=1fb1ed0e&scoped=true&"
import script from "./Substitution.vue?vue&type=script&lang=js&"
export * from "./Substitution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb1ed0e",
  null
  
)

export default component.exports